export enum EnFileUploadMode {
  document = 'document',
  single = 'single',
  list = 'list',
  preview = 'preview',
  webcam = 'webcam'
}
